<template>
  <card class="contact-wrapper">
    <el-row :gutter="20">
      <!-- 紧急联系人 -->
      <el-col v-if="type == 1" :span="24">
        <div class="contact-header">
          <AdminTitle title="联系人信息" size="15px" />

          <div class="content-col-title">
            <el-button type="primary" class="add-more" size="mini" @click="addContact">新增</el-button>
            <div class="show-more" @click="showContact">更多</div>
          </div>
        </div>

        <tp-table
          :showPagination="false"
          :tableData="orderInfo.orderMemberRelationList"
          :columns="relationColumns"
        />
      </el-col>

      <!-- 跟进记录 -->
      <el-col v-if="type == 2" :span="24">
        <div class="contact-header">
          <AdminTitle title="跟进记录" size="15px" />

          <div class="content-col-title">
            <el-button type="primary" class="add-more" size="mini" @click="addRemark">新增</el-button>
            <div class="show-more" @click="showRemark">更多</div>
          </div>
        </div>

        <tp-table
          :showPagination="false"
          :tableData="orderInfo.orderTraceList"
          :columns="traceColumns"
        />
      </el-col>
    </el-row>

    <!-- 订单详情页添加联系人 -->
    <el-dialog width="450px" title="添加联系人" :visible.sync="addVisibleContact">
      <el-form ref="formRelation" :model="contactFormData" label-width="100px">
        <el-form-item label="关系类型" prop="relationType" :rules="rules">
          <el-input
              style="width: 300px"
              v-model="contactFormData.relationType"
              size="small"
          />
        </el-form-item>
        <el-form-item label="联系人" prop="relationName" :rules="rules">
          <el-input
            style="width: 300px"
            v-model="contactFormData.relationName"
            size="small"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="relationMobile" :rules="mobileRules">
          <el-input
            style="width: 300px"
            v-model="contactFormData.relationMobile"
            size="small"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            style="width: 300px"
            type="textarea"
            v-model="contactFormData.remark"
          />
        </el-form-item>
        <div style="text-align: center;">
          <el-button @click="addVisibleContact = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveRelation" size="small">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 订单详情页联系人列表 -->
    <el-dialog title="紧急联系人" :visible.sync="outerVisibleContact" width="60%">
      <!-- 添加联系人 -->
      <div class="contact-remark-table">
        <div class="contact-add">
          <el-button class="round-button" type="info" size="mini" @click="copyRelation">复制</el-button>
          <el-button class="round-button" type="primary" size="mini" @click="addRelation">添加</el-button>
        </div>

        <tp-table
          :height="500"
          :showPagination="false"
          :tableData="contactList"
          :columns="contactColumns"
        />
      </div>
    </el-dialog>

    <!-- 联系人列表页保存 -->
    <el-dialog
      width="450px"
      title="保存联系人"
      :visible.sync="innerVisibleContact"
      append-to-body
    >
      <el-form ref="formRelation" :model="contactFormData" label-width="100px">
        <el-form-item label="与本人关系" prop="relationType" :rules="rules">
          <el-input
              style="width: 300px"
              v-model="contactFormData.relationType"
              size="small"
          />
        </el-form-item>
        <el-form-item label="联系人" prop="relationName" :rules="rules">
          <el-input
            style="width: 300px"
            v-model="contactFormData.relationName"
            size="small"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="relationMobile" :rules="mobileRules">
          <el-input
            style="width: 300px"
            v-model="contactFormData.relationMobile"
            size="small"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            style="width: 300px"
            type="textarea"
            v-model="contactFormData.remark"
          />
        </el-form-item>
        <div style="text-align: center;">
          <el-button @click="innerVisibleContact = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveRelation" size="small">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 订单详情页添加备注 -->
    <el-dialog width="450px" title="添加备注" :visible.sync="addVisibleRemark">
      <el-form ref="formRemark" :model="remarkFormData" label-width="80px">
        <el-form-item label="备注">
          <el-input
            style="width: 300px"
            type="textarea"
            v-model="remarkFormData.content"
          />
        </el-form-item>
        <div style="text-align: center">
          <el-button @click="addVisibleRemark = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleAddRemark" size="small">提 交</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 订单详情页备注列表 -->
    <el-dialog title="备注列表" :visible.sync="outerVisibleRemark" width="60%">
      <div class="contact-remark-table">
        <div class="remark-content">
          <div class="remark-input">
            <el-input
              v-model="remarkFormData.content"
              size="small"
              clearable
              placeholder="请输入"
            />
          </div>
          <div class="remark-submit">
            <el-button type="primary" size="mini" @click="handleAddRemark">新增</el-button>
          </div>
        </div>

        <tp-table
          :height=500
          :showPagination="true"
          :tableData="remarkList"
          :columns="remarkColumns"
          :totalNum="remarkTotal"
          :current-page.sync="currentPageRemark"
          :pageSize.sync="pageSizeRemark"
        />
      </div>
    </el-dialog>
  </card>
</template>

<script>
import {
    getRemarkListAPI,
    handleAddRemarkAPI,
    getRelationListAPI,
    addRelationAPI,
    editRelationAPI,
    getRelationDetailAPI,
    delRelationAPI,
    riskRelationAPI,
} from './api';

const relationColumns = [
  {
    label: '姓名',
    prop: 'relationName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['relationName']}</p>;
    },
  },
  {
    label: '电话',
    prop: 'relationMobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['relationMobile']}</p>;
    },
  },
  {
    label: '关系',
    prop: 'relationType',
    minWidth: '150',
    customRender(h, row) {
      return <div>{row['relationType']}</div>;
    },
  },
  {
    label: '匹配状态',
    prop: 'matchStatus',
    minWidth: '120',
    customRender(h, row) {
      return <div>{this.getMatchStatusName(row['matchStatus'])}</div>;
    },
  },
  {
    label: '备注',
    prop: 'remark',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['remark']}</p>;
    },
  },
];

const traceColumns = [
  {
    label: '跟进时间',
    prop: 'createTime',
    width: '240',
    customRender(h, row) {
      return <p>{row['createTime']}</p>;
    },
  },
  {
    label: '跟进人',
    prop: 'traceUserName',
    width: '160',
    customRender(h, row) {
      return <p>{row['traceUserName']}</p>;
    },
  },
  {
    label: '备注内容',
    prop: 'content',
    fixed: 'right',
    customRender(h, row) {
      return <p>{row['content']}</p>;
    },
  },
];

const contactColumns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p>{row['id']}</p>;
    },
  },
  {
    label: '姓名',
    prop: 'relationName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['relationName']}</p>;
    },
  },
  {
    label: '电话',
    prop: 'relationMobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['relationMobile']}</p>;
    },
  },
  {
    label: '关系',
    prop: 'relationType',
    minWidth: '120',
    customRender(h, row) {
      return <div>{row['relationType']}</div>;
    },
  },
  {
    label: '匹配状态',
    prop: 'matchStatus',
    minWidth: '100',
    customRender(h, row) {
      return <div>{this.getMatchStatusName(row['matchStatus'])}</div>;
    },
  },
  {
    label: '备注',
    prop: 'remark',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['remark']}</p>;
    },
  },
  {
    label: '操作',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-link
            style="margin-right:10px;"
            underline={false}
            type="primary"
            onClick={() => this.editRelation(row['id'])}
          >
            编辑
          </el-link>
          <el-link
            underline={false}
            type="primary"
            onClick={() => this.delRelation(row['id'])}
          >
            删除
          </el-link>
        </div>
      );
    },
  },
];

const remarkColumns = [
  {
    label: '跟进时间',
    prop: 'createTime',
    width: '240',
    customRender(h, row) {
      return <p>{row['createTime']}</p>;
    },
  },
  {
    label: '跟进人',
    prop: 'traceUser',
    width: '160',
    customRender(h, row) {
      return <p>{row['traceUser']?.['userName']}</p>;
    },
  },
  {
    label: '备注内容',
    prop: 'content',
    fixed: 'right',
    customRender(h, row) {
      return <p>{row['content']}</p>;
    },
  },
];

export default {
  name: 'Contact',
  props: ['member', 'orderInfo', 'type'],

  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        if (value === this.member.mobile) {
          callback(new Error('已与下单人手机号重复'));
        } else {
          callback();
        }
      }
    };
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      mobileRules: [
        { required: true, message: '该项不能为空', trigger: 'blur' },
        { validator: validateMobile, trigger: 'blur' }
      ],
      relationColumns,
      traceColumns,
      contactColumns,
      remarkColumns,
      orderNo: this.$route.params.id,
      // 编辑联系人相关
      outerVisibleContact: false,
      innerVisibleContact: false,
      addVisibleContact: false,
      contactList: [],
      contactFormData: {
        relationName: '',
        relationMobile: '',
        relationType: '',
        remark: '',
      },
      // 备注相关
      outerVisibleRemark: false,
      innerVisibleRemark: false,
      addVisibleRemark: false,
      remarkList: [],
      remarkFormData: {
        content: '',
        orderNo: this.$route.params.id,
      },
      currentPageRemark: 1,
      pageSizeRemark: 10,
      remarkTotal: 0,
      orderTraceContent: '',
    };
  },

  provide() {
    return {
      context: this,
    };
  },

  watch: {
    currentPageRemark() {
      this.getRemarkList();
    },
    pageSizeRemark() {
      this.getRemarkList();
    },
  },

  methods: {
    getMatchStatusName(matchStatus) {
      if (matchStatus === 1) {
        return '匹配';
      } else if (matchStatus === 2) {
        return '不匹配';
      } else {
        return '-';
      }
    },
    // 查看联系人
    showContact() {
      this.outerVisibleContact = true;
      this.getRelationList();
    },

    // 联系人列表
    async getRelationList() {
      this.contactList = await getRelationListAPI(this.orderNo);
    },

    // 打开添加弹窗
    addRelation() {
      this.innerVisibleContact = true;
      this.contactFormData = {
        orderNo: this.orderNo,
        relationName: '',
        relationMobile: '',
        relationType: '',
        remark: '',
      };
    },

    // 添加联系人
    async saveRelation() {
      this.$refs.formRelation.validate(async (valid) => {
        if (valid) {
          const { id, relationMobile } = this.contactFormData;
          const { riskAlertList } = await riskRelationAPI({ id, relationMobile });
          if (riskAlertList.length === 0) {
            return this.submitRelation();
          } else {
            this.$confirm('<div>' + riskAlertList.join('<br>') + '</div>', '提示', {
              confirmButtonText: '继续提交',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning',
            })
              .then(() => {
                this.submitRelation();
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消保存',
                });
              });
          }
        } else {
          return false;
        }
      });
    },

    // 提交
    submitRelation() {
      if (this.contactFormData.id) {
        editRelationAPI(this.contactFormData).then(() => {
          this.$message.success('编辑成功');
          this.innerVisibleContact = false;
          this.getRelationList();
          this.$emit('update:flag', true);
          this.$emit('updateDetail');
        });
      } else {
        addRelationAPI(this.contactFormData).then(() => {
          this.$message.success('添加成功');
          this.innerVisibleContact = false;
          this.addVisibleContact = false;
          this.getRelationList();
          this.$emit('update:flag', true);
          this.$emit('updateDetail');
        });
      }
    },

    // 编辑联系人
    editRelation(id) {
      this.innerVisibleContact = true;
      this.getRelationDetail(id);
    },

    addContact() {
      this.addVisibleContact = true;
      this.contactFormData = {
        orderNo: this.orderNo,
        relationName: '',
        relationMobile: '',
        relationType: '',
        remark: '',
      };
    },
    async getRelationDetail(id) {
      this.contactFormData = await getRelationDetailAPI(id);
    },

    delRelation(id) {
      this.$confirm('此操作将永久删除该联系人, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delRelationAPI(id).then(() => {
            this.getRelationList();
            this.$emit('update:flag', true);
            this.$emit('updateDetail');
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    // 复制
    copyRelation() {
      const { contactList } = this;
      let str = '';
      contactList.forEach((item) => {
        str = str +
            item.relationName +
            '，' +
            item.relationMobile +
            '，' +
            item.relationType +
            '，' +
            item.remark +
            '\n';
      });
      this.$copyText(str).then(
        () => {
          this.$message.success('复制成功');
        },
        () => {
          this.$message.error('复制失败');
        }
      );
    },

    // ====备注====
    async getRemarkList() {
      let params = {
        orderNo: this.$route.params.id,
        page: this.currentPageRemark,
        pageSize: this.pageSizeRemark,
      };
      const res = await getRemarkListAPI(params);
      this.remarkList = res.list || [];
      this.remarkTotal = res.total || 0;
    },

    // 查看备注
    showRemark() {
        this.outerVisibleRemark = true;
        this.remarkFormData = {
          orderNo: this.$route.params.id,
          content: '',
        };
        this.getRemarkList();
    },

    addRemark() {
      this.addVisibleRemark = true;
      this.remarkFormData = {
        orderNo: this.$route.params.id,
        content: '',
      };
    },

    //  添加备注
    handleAddRemark() {
      handleAddRemarkAPI(this.remarkFormData).then(() => {
        this.$message.success('新增成功');
        this.getRemarkList();
        this.remarkFormData.content = '';
        this.innerVisibleRemark = false;
        this.addVisibleRemark = false;
        this.$emit('update:flag', true);
        this.$emit('updateDetail');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-wrapper ::v-deep {
  width: 100%;
  border-color: transparent;
  border-radius: 16px;
  color: #222222;

  .contact-header {
    margin-bottom: 5px;

    .para-title {
      font-size: 20px;
      font-weight: bold;
      padding: 5px 0;
    }
  }

  .el-dialog__body {
      padding-top: 10px;
  }

  .contact-remark {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .item {
      background: #fafafa;
      flex: 1;
      border: 1px solid #ebeef5;
      padding: 5px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:first-child {
        margin-right: 20px;
      }
    }
  }

  .contact-remark-table {
    .tp-table {
      .el-table__fixed-right {
        height: 100% !important;

        &::before {
            display: none;
        }
      }
    }

    .remark-content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .remark-input {
        flex: 1;
        margin-right: 20px;
      }
    }

    .contact-add {
      text-align: right;
      margin-bottom: 20px;
    }
  }

  .el-dialog__body {
    padding: 30px;
  }

  .content-col-title {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 5px;
    gap: 5px;
  }

  .content-col-trace {
    line-height: 40px;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .content-remark-input {
      width: 30%;
      margin-right: 20px;
      .el-input__inner {
        border: none;
        background: #f7f8fa;
      }
    }
  }

  .add-more {
    margin-left: 15px;
    border-radius: 15px;
    font-size: 12px;
  }

  .show-more {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 15px;
    color: #333333;
    padding: 6px 14px;
    font-size: 12px;
    background: #f7f8fa;
  }
}

.round-button {
    border-radius: 15px;
}

.add-new {
    background: #409EFF;
    color: #fff;
    border: none;
}

.without-layout .contact-wrapper ::v-deep {
  .el-table__header .el-table__cell {
    font-weight: 600;
  }
}
</style>
